import { Model } from '@/clients/http'

import { CourierHttpParams, CourierResponses } from '@/types'

export class PathaoModel extends Model {
  public static readonly correlations = {
    GET_STORES: 'GET_PATHAO_STORES',
    GET_CITIES: 'GET_PATHAO_CITIES',
    GET_ZONES: 'GET_PATHAO_ZONES',
    GET_AREAS: 'GET_PATHAO_AREAS',
    CREATE_PARCEL: 'CREATE_PATHAO_PARCEL',
    TRACK_PARCEL: 'TRACK_PATHAO_PARCEL',
    CANCEL_PARCEL: 'CANCEL_PATHAO_PARCEL',
  }

  public static readonly endpoints = {
    getStores: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/store',
      }),

    getCities: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/city',
      }),

    getZones: (props?: CourierHttpParams.GetPathaoZones) =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/city/:cityId/zone',
        params: props?.params,
      }),

    getAreas: (props?: CourierHttpParams.GetPathaoAreas) =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/zone/:zoneId/area',
        params: props?.params,
      }),

    createParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/create-parcel',
      }),

    trackParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/track-parcel',
      }),

    cancelParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/pathao/cancel-parcel',
      }),
  }

  public static readonly getStores = async (props?: CourierHttpParams.GetPathaoStores) => {
    return this.createHttpRequest<
      CourierResponses.GetPathaoStores,
      CourierResponses.GetPathaoStoresError
    >({
      correlationKey: this.correlations.GET_STORES,
      payload: {
        method: 'get',
        url: this.endpoints.getStores(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getCities = async (props?: any) => {
    return this.createHttpRequest<CourierResponses.GetPathaoCities, any>({
      correlationKey: this.correlations.GET_CITIES,
      payload: {
        method: 'get',
        url: this.endpoints.getCities(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getZones = async (props: CourierHttpParams.GetPathaoZones) => {
    return this.createHttpRequest<
      CourierResponses.GetPathaoZones,
      CourierResponses.GetPathaoZonesError
    >({
      correlationKey: this.correlations.GET_ZONES,
      payload: {
        method: 'get',
        url: this.endpoints.getZones(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getAreas = async (props: CourierHttpParams.GetPathaoAreas) => {
    return this.createHttpRequest<
      CourierResponses.GetPathaoAreas,
      CourierResponses.GetPathaoAreasError
    >({
      correlationKey: this.correlations.GET_AREAS,
      payload: {
        method: 'get',
        url: this.endpoints.getAreas(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly createParcel = async (props: CourierHttpParams.CreatePathaoParcel) => {
    return this.createHttpRequest<
      CourierResponses.CreatePathaoParcel,
      CourierResponses.CreatePathaoParcelError
    >({
      correlationKey: this.correlations.CREATE_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.createParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly trackParcel = async (props: CourierHttpParams.TrackPathaoParcel) => {
    return this.createHttpRequest<
      CourierResponses.TrackPathaoParcel,
      CourierResponses.TrackPathaoParcelError
    >({
      correlationKey: this.correlations.TRACK_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.trackParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly cancelParcel = async (props: CourierHttpParams.CancelPathaoParcel) => {
    return this.createHttpRequest<
      CourierResponses.CancelPathaoParcel,
      CourierResponses.CancelPathaoParcelError
    >({
      correlationKey: this.correlations.CANCEL_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.cancelParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
